export function redirectBrowser(url: string): void {
    // Added this to ensure that we can swap this out for testing
    // at some point.
    window.location.replace(url);
}